import type { Point } from "./geometry";

export const MAX_TILT_OFFSET = 10;

export class TiltParallax {
  private baseline: { beta: number; gamma: number; angle: number } | null =
    null;

  reset(): void {
    this.baseline = null;
  }

  sample(beta: number | null, gamma: number | null, angle: number): Point {
    if (
      beta === null ||
      gamma === null ||
      !Number.isFinite(beta) ||
      !Number.isFinite(gamma) ||
      !Number.isFinite(angle)
    ) {
      this.reset();
      return { x: 0, y: 0 };
    }
    if (!this.baseline || this.baseline.angle !== angle) {
      this.baseline = { beta, gamma, angle };
      return { x: 0, y: 0 };
    }
    const betaDelta = ((beta - this.baseline.beta + 540) % 360) - 180;
    const gammaDelta = gamma - this.baseline.gamma;
    const radians = (angle * Math.PI) / 180;
    const x =
      (gammaDelta * Math.cos(radians) + betaDelta * Math.sin(radians)) * 0.35;
    const y =
      (betaDelta * Math.cos(radians) - gammaDelta * Math.sin(radians)) * 0.35;
    const scale = Math.min(1, MAX_TILT_OFFSET / Math.max(1, Math.hypot(x, y)));
    return { x: x * scale, y: y * scale };
  }
}
